import { ComponentF, createElement } from "../../../ui/ui";
import {
  findActorForPosition,
  gameData,
  getItemsForPosition,
} from "../../GameManager";
import { SpellDetailDisplay } from "../book/SpellDetailDisplay";
import { ItemDetailDisplay } from "../inventory/ItemDetailDisplay";
import { ActorDetailDisplay } from "./ActorDetailsDisplay";
import { DepthInfo } from "./DepthInfo";

export const TileContents: ComponentF<void> = (C) => {
  /** Render Selected spell if available */
  if (gameData.selectedSpell) {
    return [
      createElement(
        SpellDetailDisplay,
        { x: 1, y: 0, w: C.bounds.w - 2, h: C.bounds.h },
        { spell: gameData.selectedSpell }
      ),
    ];
  }

  if (gameData.selectedItem) {
    return [
      createElement(
        ItemDetailDisplay,
        { x: 1, y: 0, w: C.bounds.w - 2, h: C.bounds.h },
        { item: gameData.selectedItem }
      ),
    ];
  }

  let x, y;
  if (gameData.focus != null) {
    x = gameData.focus.x;
    y = gameData.focus.y;
  } else {
    x = gameData.player.x;
    y = gameData.player.y;
  }

  const items = getItemsForPosition(x, y);
  const actor = findActorForPosition(x, y);

  if (actor && actor != gameData.player) {
    return [
      createElement(
        ActorDetailDisplay,
        { x: 0, y: 0, w: C.bounds.w, h: C.bounds.h },
        { actor }
      ),
    ];
  } else if (!actor && items.length) {
    return [
      createElement(
        ItemDetailDisplay,
        { x: 0, y: 0, w: C.bounds.w, h: C.bounds.h },
        { item: items[0] }
      ),
    ];
  } else {
    return [
      createElement(DepthInfo, {
        x: 0,
        y: 0,
        h: 1,
        w: C.bounds.w,
      }),
    ];
  }
};
